import CircularProgress from '@material-ui/core/CircularProgress/CircularProgress'
import React, {
    ComponentType,
    forwardRef,
    lazy,
    ReactNode,
    Ref,
    Suspense,
} from 'react'

/**
 * HOC to wrap a component with React.lazy and Suspense for code splitting,
 * and forward refs to the lazy-loaded component.
 * @param importFunc - The function to dynamically import the component.
 * @returns The wrapped component with lazy loading and ref forwarding.
 */
export const withLazyLoadRef = <TProps extends object, TRef = unknown>(
    importFunc: () => Promise<{
        default: ComponentType<TProps & { ref?: Ref<TRef> }>
    }>,
    fallback: ReactNode = <CircularProgress size={16} />
) => {
    const LazyComponent = lazy(importFunc)

    return forwardRef<TRef, TProps>((props, ref) => (
        <Suspense fallback={fallback}>
            <LazyComponent {...props} ref={ref} />
        </Suspense>
    ))
}
